<!-- The explanation hangs off the header itself rather than off the icon beside the label. The icon
     sits inside a button, where nothing of its own can hold focus, so a separate control there
     would be unreachable by keyboard. -->
<button type="button"
        (click)="sortBy()"
        class="btn btn-link p-0"
        [edlTooltip]="tooltip"
        [edlTooltipConfig]="tooltipConfig">
    {{ label }}
    <!-- Beside the label, where it marks what the label names, rather than out with the sort arrows. -->
    <i *ngIf="tooltip" [ngClass]="tooltipIcon" aria-hidden="true"></i>
    <i class="fas fa-sort" aria-hidden="true"></i>
    <span class="visually-hidden">Sort</span>
</button>
